import { useCallback, useEffect, useRef, type MutableRefObject } from 'react';
import { useIsAnyMenuOpen, useContextMenuActions } from '../context-menu/index.tsx';

export const useCloseMenuOnScroll = (ref: MutableRefObject<HTMLDivElement | null>) => {
	const { reset } = useContextMenuActions();
	const isAnyMenuOpen = useIsAnyMenuOpen();
	const added = useRef(false);

	const handleScroll = useCallback(() => {
		reset({ action: 'closeMenu' });
	}, [reset]);

	useEffect(() => {
		if (ref.current) {
			if (isAnyMenuOpen) {
				if (!added.current) {
					ref.current.addEventListener('scroll', handleScroll);
					added.current = true;
				}
				return;
			}
			if (added.current) {
				ref.current.removeEventListener('scroll', handleScroll);
				added.current = false;
			}
		}
	}, [handleScroll, ref, isAnyMenuOpen]);

	useEffect(
		() => () => {
			if (ref.current && added.current) {
				ref.current.removeEventListener('scroll', handleScroll);
				added.current = false;
			}
		},
		[ref, handleScroll],
	);
};
